var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:[
    { 'button--disabled': _vm.disabled },
    { 'flat': _vm.flat },
    _vm.expandedClassObject,
    _vm.btnBackgroundColor,
    _vm.btnWidth,
    _vm.btnHeight,
    _vm.btnFontSize,
    _vm.btnPredefinedStyle,
    { 'button--active': _vm.active }
],on:{"click":function($event){_vm.emitClick()}}},[_c('span',{staticClass:"button__text-btn"},[_vm._t("btn-text",[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }